import React from 'react';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';

const FetchFailureMessage: React.SFC<{}> = () => (
  <FormattedText 
    style='fetch-failure-message'
    displayName='Något gick fel... Försök gärna igen om en stund.'
    formattedName='global.fetchfailed'  
  />
);
  
export default FetchFailureMessage;


// WEBPACK FOOTER //
// ./src/components/Shared/FetchFailureMessage/FetchFailureMessage.tsx